import { Descriptions } from "@/components/v2";
import { Button, Card } from "@rumbledirect/ui";
import { Popconfirm, Space, type DescriptionsProps } from "antd";
import { Link } from "react-router-dom";
import { UseMutationResult } from "@tanstack/react-query";
import { Role } from "@rumble-it/common-lib/types/models/Role.interface";

interface RoleDetailCardProps {
  role?: Role;
  isLoading?: boolean;
  deleteMutation?: UseMutationResult<null, Error, void, unknown>;
}

export const RoleDetailCard = ({
  role,
  isLoading,
  deleteMutation,
}: RoleDetailCardProps) => {
  return (
    <Card
      loading={isLoading}
      className="w-full"
      title="Rol"
      extra={
        <Space>
          <Link to={`/roles/${role?.id}/edit`}>
            <Button>Bewerken</Button>
          </Link>
          <Popconfirm
            title="Rol verwijderen"
            description="Weet je zeker dat je deze rol wilt verwijderen?"
            onConfirm={() => deleteMutation?.mutate()}
            okText="Ja"
            cancelText="Nee"
          >
            <Button danger loading={deleteMutation?.isPending}>
              Verwijderen
            </Button>
          </Popconfirm>
        </Space>
      }
    >
      {(() => {
        const items: DescriptionsProps["items"] = [
          { label: "Naam", children: role?.name ?? null },
          {
            label: "Externe SSO-groep",
            children: role?.externalSsoGroup ?? "-",
          },
          { label: "Pending", children: role?.pending ? "Ja" : "Nee" },
          {
            label: "Dealership verplicht",
            children: role?.dealershipRequired ? "Ja" : "Nee",
          },
          { label: "Systeem", children: role?.system ? "Ja" : "Nee" },
          {
            label: "Aantal permissies",
            children: role?.permissions?.length || 0,
          },
        ];
        return <Descriptions items={items} />;
      })()}
    </Card>
  );
};
